/* ===== eightdays dining — Top Page Scripts ===== */

// ===== HERO SLIDESHOW =====
(function initHeroSlideshow() {
  const container = document.querySelector('.ed-hero');
  if (!container) return;

  const slides = container.querySelectorAll('.ed-hero-slide');
  const indicators = container.querySelectorAll('.ed-hero-indicator');
  if (slides.length === 0) return;

  let current = 0;
  let interval;
  const DURATION = 5000;

  function goTo(index) {
    slides[current].classList.remove('active');
    if (indicators[current]) indicators[current].classList.remove('active');
    current = index;
    slides[current].classList.add('active');
    if (indicators[current]) indicators[current].classList.add('active');
  }

  function next() {
    goTo((current + 1) % slides.length);
  }

  function startAutoPlay() {
    interval = setInterval(next, DURATION);
  }

  function resetAutoPlay() {
    clearInterval(interval);
    startAutoPlay();
  }

  indicators.forEach(function(btn) {
    btn.addEventListener('click', function() {
      goTo(parseInt(btn.dataset.index));
      resetAutoPlay();
    });
  });

  // Preload images
  slides.forEach(function(slide) {
    var bg = slide.style.backgroundImage;
    if (bg) {
      var img = new Image();
      img.src = bg.slice(5, -2);
    }
  });

  startAutoPlay();
})();

// ===== MENU TABS (across separate sections) =====
(function initMenuTabs() {
  var tabsContainer = document.getElementById('edMenuTabs');
  if (!tabsContainer) return;

  var allTabSections = document.querySelectorAll('.ed-menu-tab-section');
  var allGrids = document.querySelectorAll('.ed-menu-tab-content');
  var allWrappers = document.querySelectorAll('.ed-menu-grid-wrapper');
  if (allGrids.length === 0) return;

  // Build tab buttons from each section's data attribute
  allTabSections.forEach(function(section, index) {
    var label = section.dataset.menuTabLabel;
    if (!label) return;

    var btn = document.createElement('button');
    btn.className = 'ed-menu-tab' + (index === 0 ? ' active' : '');
    btn.textContent = label;
    btn.dataset.tabIndex = index;
    tabsContainer.appendChild(btn);
  });

  // Tab switching — toggle entire section wrappers to keep margins consistent
  var allMoreBtns = document.querySelectorAll('.ed-menu-more');

  tabsContainer.addEventListener('click', function(e) {
    var btn = e.target.closest('.ed-menu-tab');
    if (!btn) return;

    var idx = parseInt(btn.dataset.tabIndex);

    tabsContainer.querySelectorAll('.ed-menu-tab').forEach(function(t) {
      t.classList.remove('active');
    });
    btn.classList.add('active');

    // For the first section (index 0), show/hide its own grid inline.
    // For non-first sections, toggle the whole section wrapper via active-tab class.
    allTabSections.forEach(function(section, i) {
      var grid = allGrids[i];
      var moreBtn = allMoreBtns[i];

      if (i === 0) {
        // First section: toggle inner content display + bottom padding
        section.style.paddingBottom = (idx === 0) ? '' : '0';
        if (allWrappers[i]) allWrappers[i].style.display = (i === idx) ? '' : 'none';
        if (moreBtn) {
          moreBtn.style.display = (i === idx) ? '' : 'none';
          if (i === idx) moreBtn.classList.add('visible');
        }
      } else {
        // Non-first sections: toggle entire section wrapper + Shopify parent
        section.classList.toggle('active-tab', i === idx);
        var wrapper = section.closest('.shopify-section');
        if (wrapper) wrapper.style.display = (i === idx) ? '' : 'none';
        // Reset inline display styles since CSS handles visibility
        if (allWrappers[i]) allWrappers[i].style.display = '';
        if (grid) grid.style.display = '';
        if (moreBtn) {
          moreBtn.style.display = '';
          if (i === idx) moreBtn.classList.add('visible');
        }
      }

      // Trigger reveal animations for newly shown cards
      if (i === idx && grid) {
        grid.querySelectorAll('.ed-reveal:not(.visible)').forEach(function(el) {
          el.classList.add('visible');
        });
      }
    });
  });
})();

// ===== MENU CAROUSEL (Mobile) =====
(function initMenuCarousel() {
  var isMobile = function() { return window.innerWidth <= 600; };

  document.querySelectorAll('.ed-menu-grid-wrapper').forEach(function(wrapper) {
    var track = wrapper.querySelector('.ed-menu-grid');
    var cards = track.querySelectorAll('.ed-menu-card');
    var dots = wrapper.querySelectorAll('.ed-menu-grid-dot');
    if (cards.length < 2 || dots.length === 0) return;

    var currentIndex = 0;

    function scrollToCard(index) {
      if (!isMobile()) return;
      currentIndex = Math.max(0, Math.min(index, cards.length - 1));
      var card = cards[currentIndex];
      var offset = card.offsetLeft - (track.offsetWidth / 2) + (card.offsetWidth / 2);
      track.scrollTo({ left: offset, behavior: 'smooth' });
      updateDots();
    }

    function updateDots() {
      dots.forEach(function(dot, i) {
        dot.classList.toggle('active', i === currentIndex);
      });
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        scrollToCard(parseInt(dot.dataset.menuCardIndex));
      });
    });

    var scrollTimeout;
    track.addEventListener('scroll', function() {
      if (!isMobile()) return;
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        var trackCenter = track.scrollLeft + track.offsetWidth / 2;
        var closest = 0;
        var minDist = Infinity;
        cards.forEach(function(card, i) {
          var cardCenter = card.offsetLeft + card.offsetWidth / 2;
          var dist = Math.abs(trackCenter - cardCenter);
          if (dist < minDist) { minDist = dist; closest = i; }
        });
        currentIndex = closest;
        updateDots();
      }, 100);
    });
  });
})();

// ===== MODAL =====
(function initModal() {
  var overlay = document.getElementById('edMenuModal');
  if (!overlay) return;

  var modalImg = document.getElementById('edModalImg');
  var modalTitle = document.getElementById('edModalTitle');
  var modalPrice = document.getElementById('edModalPrice');
  var modalDesc = document.getElementById('edModalDesc');
  var modalClose = document.getElementById('edModalClose');

  // Open modal from menu card
  document.addEventListener('click', function(e) {
    var card = e.target.closest('.ed-menu-card');
    if (!card) return;

    if (modalImg) modalImg.style.backgroundImage = "url('" + card.dataset.img + "')";
    if (modalTitle) modalTitle.textContent = card.dataset.name;
    if (modalPrice) modalPrice.textContent = card.dataset.price;
    if (modalDesc) modalDesc.textContent = card.dataset.desc;
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  });

  function closeModal() {
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (modalClose) modalClose.addEventListener('click', closeModal);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeModal();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeModal();
  });
})();

// ===== SCROLL REVEAL =====
(function initScrollReveal() {
  // Auto-apply ed-reveal to common section content elements
  var autoSelectors = [
    '.ed-faq-item',
    '.ed-contact-field',
    '.ed-contact-field-full',
    '.ed-contact-submit',
    '.ed-contact-desc',
    '.ed-facility-card',
    '.ed-scene-card',
    '.ed-menu-card',
    '.ed-cases-card',
    '.ed-ig-item'
  ];
  autoSelectors.forEach(function(sel) {
    document.querySelectorAll(sel).forEach(function(el, i) {
      if (!el.classList.contains('ed-reveal')) {
        el.classList.add('ed-reveal');
        // Stagger items in groups
        var delay = Math.min(i * 0.06, 0.3);
        el.style.transitionDelay = delay + 's';
      }
    });
  });

  var reveals = document.querySelectorAll('.ed-reveal');
  var illusts = document.querySelectorAll('.ed-illust');

  if (reveals.length === 0 && illusts.length === 0) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  reveals.forEach(function(el) { observer.observe(el); });
  illusts.forEach(function(el) { observer.observe(el); });
})();

// ===== NAV DOTS =====
(function initNavDots() {
  var dotsContainer = document.getElementById('edNavDots');
  if (!dotsContainer) return;

  var dots = dotsContainer.querySelectorAll('.ed-nav-dot');
  var sectionIds = [];

  dots.forEach(function(dot) {
    sectionIds.push(dot.dataset.section);
  });

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var id = entry.target.id;
        dots.forEach(function(d) {
          d.classList.toggle('active', d.dataset.section === id);
        });
      }
    });
  }, { threshold: 0.3 });

  sectionIds.forEach(function(id) {
    var el = document.getElementById(id);
    if (el) observer.observe(el);
  });

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      var el = document.getElementById(dot.dataset.section);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    });
  });
})();
